































































import moment from "moment";
import momentTimezone from "moment-timezone";
import { Component, Vue } from "vue-property-decorator";
import {
  formatDateReadable,
  formatTimeReadable,
  dateToDay
} from "@/utils/time";
import { getBookingSummary } from "@/api/bookings";
import { BookingSummary } from "../api/types";
import { ShopsModule } from "@/store/modules/shops";
import SbSpinner from "@/components/Spinner.vue";

@Component({
  name: "Shop",
  components: {
    SbSpinner
  }
})
export default class extends Vue {
  private bookingSummary!: BookingSummary;

  get shop() {
    return ShopsModule.shop;
  }

  get accentColor() {
    return this.shop.colorTheme;
  }

  get shopStyles() {
    return {
      "--sb-shop-accent-color": this.accentColor
    };
  }

  get dateFormatted(): string {
    const { bookingSummary } = this;

    if (!bookingSummary) return "";

    // TODO remove this patch
    // backend should store the formatted booking time in the booking
    // with respect to the store's timezone
    const date = moment(bookingSummary.start)
      .tz("GMT")
      .format("YYYY-MM-DD");

    const dayReadable = dateToDay(date);
    const dateReadable = formatDateReadable(date);

    return `${dayReadable}, ${dateReadable}`;
  }

  get startTimeFormatted(): string {
    const { bookingSummary } = this;

    if (!bookingSummary) return "";

    // TODO remove this patch
    // backend should store the formatted booking time in the booking
    // with respect to the store's timezone
    const time = momentTimezone(bookingSummary.start)
      .tz("GMT")
      .format("HH:mm");

    return formatTimeReadable(time);
  }

  get endTimeFormatted(): string {
    const { bookingSummary } = this;

    if (!bookingSummary) return "";

    // TODO remove this patch
    // backend should store the formatted booking time in the booking
    // with respect to the store's timezone
    const time = momentTimezone(bookingSummary.end)
      .tz("GMT")
      .format("HH:mm");

    return formatTimeReadable(time);
  }

  async loadData() {
    try {
      const { bookingId } = this.$route.params;
      if (!bookingId) throw { message: "Invalid booking ID." };
      this.bookingSummary = await getBookingSummary({ bookingId });
      await ShopsModule.getShop(this.bookingSummary.storeId);
    } catch (e) {
      this.$router.push("/");
      console.log(e);
    }
  }

  created() {
    this.loadData();
  }
}
